var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_4897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2136 6.2592C13.0291 6.0748 12.9073 5.82581 12.8876 5.54499C12.8436 4.92627 13.3101 4.38897 13.9293 4.34498C16.4293 4.16713 18.9266 5.1893 20.962 7.22239C22.7821 9.04113 23.7459 11.4599 23.6747 14.0321C23.6579 14.6518 23.1408 15.1414 22.5198 15.1236C21.8997 15.1067 21.4098 14.59 21.4276 13.9694C21.481 12.0206 20.7513 10.1878 19.3725 8.80993C18.2634 7.70165 16.4471 6.41645 14.0885 6.58401C13.7503 6.60834 13.4356 6.48011 13.2136 6.25733V6.2592Z",
    fill: "url(#paint0_linear_159_4897)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1355 1.94136C13.951 1.75696 13.8292 1.50797 13.8095 1.22715C13.7655 0.608426 14.232 0.0711346 14.8511 0.0271403C18.2148 -0.212488 21.5823 1.17005 24.3343 3.92016C26.7913 6.37542 28.0915 9.63942 27.995 13.1112C27.9781 13.7318 27.4611 14.2204 26.84 14.2027C26.219 14.1858 25.73 13.6691 25.7478 13.0485C25.8265 10.2001 24.7596 7.52208 22.7448 5.5077C20.4273 3.19192 17.753 2.07147 15.0104 2.2671C14.6722 2.29144 14.3575 2.1632 14.1355 1.94042V1.94136Z",
    fill: "url(#paint1_linear_159_4897)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5674 21.7594L21.9423 18.1369C21.1508 17.3459 19.8685 17.3459 19.077 18.1369L18.0129 19.2002L17.6372 19.5756L16.7493 20.463C16.7493 20.463 16.6022 20.6099 15.8734 20.2795C15.1484 19.95 12.6474 18.3372 11.1908 16.8414C11.1908 16.8414 11.1833 16.833 11.1787 16.8292C11.1749 16.8255 11.1712 16.8217 11.1674 16.8171C9.67057 15.3615 8.05663 12.8613 7.72691 12.1378C7.39531 11.4095 7.54331 11.2626 7.54331 11.2626L8.43131 10.3752L8.80693 9.99983L9.87103 8.93648C10.6625 8.14552 10.6625 6.86407 9.87103 6.07311L6.24504 2.44967C5.45352 1.65871 4.17117 1.65871 3.37966 2.44967L2.42515 3.4035L1.93994 3.88837L1.10627 4.72145C-0.0168365 5.84284 -0.288481 7.57078 0.3082 9.8875C2.04673 16.0008 6.84828 20.6399 7.11337 20.8926C7.36628 21.1575 12.0077 25.9548 18.1262 27.693C20.4446 28.2883 22.1737 28.0169 23.2959 26.8955L24.1296 26.0624L24.6148 25.5775L25.5693 24.6237C26.3608 23.8327 26.3608 22.5513 25.5693 21.7603L25.5674 21.7594Z",
    fill: "url(#paint2_linear_159_4897)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_159_4897",
    x1: 18.2816,
    y1: 4.32513,
    x2: 18.2816,
    y2: 15.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE192D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D529B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_159_4897",
    x1: 20.9033,
    y1: 0.000488281,
    x2: 20.9033,
    y2: 14.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE192D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D529B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_159_4897",
    x1: 13.0815,
    y1: 1.85645,
    x2: 13.0815,
    y2: 28.0004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE192D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D529B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_4897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCall);
export default __webpack_public_path__ + "static/media/icon-call.e812165e4b4f653976f8c1f71b4d75df.svg";
export { ForwardRef as ReactComponent };